import React from 'react';
import { FaTrash } from 'react-icons/fa';

const FormWrapper = props => {
  const { heading,onBlur,closeForm,onSubmit,undoEdit,edit,onDelete,children } = props;

  return (
    <div tabIndex="0" id="form-wrapper" onBlur={onBlur} style={{...styles.container, width: edit ? '95%' : '80%', height: edit ? '100%' : '75%', backgroundColor: edit ? 'rgba(0,0,0,0.1)' : 'white', color: edit ? 'white' : 'black' }}>
      <div style={styles.headerContainer}>
        <div style={styles.header}>
          <p style={styles.title}>{heading}</p>
          {(edit && onDelete) && <FaTrash style={styles.trashIcon} onClick={onDelete} />}
        </div>

        {!edit
          ? <button className="track-changes" style={styles.button} onClick={closeForm}>close</button>
          : <button style={styles.button} onClick={undoEdit}>undo changes</button>
        }
      </div>

      {children}

      <div style={styles.saveContainer}>
        <button style={styles.button} onClick={onSubmit}>{edit ? 'Save Changes' : 'Save'}</button>
      </div>
    </div>
  )
}

export default FormWrapper;

const styles = {
  container: {
    position: 'relative',
    padding: '2vmin',
    paddingTop: '.5vmin',
    margin: 'auto',
    border: '2px solid grey',
    borderRadius: 5,
    overflowY: 'auto',
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start'
  },
  title: {
    margin: 0,
    fontSize: '2.8vmin',
    fontWeight: 'bold',
    marginBottom: '2vmin',
    marginTop: '2vmin'
  },
  trashIcon: {
    backgroundColor: 'white',
    fontSize: '2vmin',
    marginLeft: '2vmin',
    padding: '.5vmin',
    border: '2px solid tomato',
    borderRadius: 5,
    color: 'tomato',
    cursor: 'pointer',
    width: '3vmin',
    height: '3vmin',
  },
  button: {
    fontSize: '1.6vmin',
    cursor: 'pointer'
  },
  saveContainer: {
    textAlign: 'center',
    margin: '4vmin auto',
  },
}